import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { LoaderComponent } from '../zoneiqui/components';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private overlayRef: OverlayRef = null;

    constructor(private overlay: Overlay) {}

    show() {
        this.hide();
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create();
        }

        const spinnerOverlayPortal = new ComponentPortal(LoaderComponent);
        this.overlayRef.attach(spinnerOverlayPortal);
    }

    hide() {
        if (!!this.overlayRef) {
            this.overlayRef.detach();
        }
    }
}
